module.exports = __webpack_public_path__ + "media/site_templates/www.hirecarpenters.com.au/images/about_us-0c641112fdfa7588d70c03feaa866b11.jpg";